import { PATHNAMES } from 'constants/constants';
import type { RouteObject } from 'react-router';
import { Navigate, useParams } from 'react-router';
import { lazyRoute } from 'utils/lazyRoute';

const PatentDraft = lazyRoute(
  () => import('features/PatentDrafting/components'),
  m => m.PatentDraft,
);
const PatentDraftResolver = lazyRoute(
  () => import('features/PatentDrafting/components/PatentDraftResolver'),
  m => m.PatentDraftResolver,
);

const ChemicalIdRedirect = () => {
  'use memo';
  const { id } = useParams();
  return <Navigate to={`${PATHNAMES.patentDrafting}/patent/${id}`} replace />;
};

export const patentDraftingDisclosureRoutes: RouteObject[] = [
  { path: `${PATHNAMES.patentDrafting}/disclosure/:id`, lazy: PatentDraft },
];

export const patentDraftingPatentRoutes: RouteObject[] = [
  { path: `${PATHNAMES.patentDrafting}/patent/:id`, lazy: PatentDraft },
  // Legacy chemical URLs — preserved as redirects so existing bookmarks still resolve.
  {
    path: `${PATHNAMES.patentDrafting}/chemical`,
    element: <Navigate to={`${PATHNAMES.patentDrafting}/patent`} replace />,
  },
  { path: `${PATHNAMES.patentDrafting}/chemical/:id`, Component: ChemicalIdRedirect },
];

export const patentDraftingResolverRoutes: RouteObject[] = [
  { path: `${PATHNAMES.patentDrafting}/:id`, lazy: PatentDraftResolver },
];
